module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "peopleTray",
    on: {
      "scroll": function($event) {
        _vm.scroll($event)
      }
    }
  }, [_c('div', {
    staticClass: "peopleContainer"
  }, [_c('div', {
    staticClass: "peopleList"
  }, [_vm._l((_vm.people), function(person, index) {
    return _c('div', {
      key: index,
      staticClass: "icon-wrapper"
    }, [_c('personicon', {
      attrs: {
        "attendee": person
      },
      on: {
        "openCard": _vm.openCard
      }
    })], 1)
  }), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "background-message"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('str.NobodyInTheSession')))])]) : _vm._e()], 2), _vm._v(" "), (_vm.attendee) ? _c('personcard', {
    attrs: {
      "attendee": _vm.attendee,
      "user": _vm.user
    },
    on: {
      "cardClosed": _vm.cardClosed
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.people === undefined) ? _c('spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56fbf8cd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PeopleTray.vue
// module id = 475
// module chunks = 0